/* eslint-disable react/static-property-placement */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable @typescript-eslint/ban-types */

//
import React, { Component } from "react"
import PropTypes from "prop-types"

// helpers
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
import { checkIfShouldShowSchoolBoard } from "shared/imports/permissionFunctions"

import {
    federalRegions,
    stateRegions,
    localRegions,
    federalAndStates,
    usRegions,
    usAndCanadaRegions,
    usCanadaEURegion,
    euRegion,
    euRegions,
    internationalNoEURegion,
    internationalRegions,
    allRegionsExceptUS,
    allRegionsExceptLocal,
    globalRegions,
} from "shared/imports/regionConstants"

import { getElectionYearSelectOptions, MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"

import {
    enumSingleGenericFilter,
    textGenericFilter,
    addressGenericFilter,
    createProfileToggleFilter,
    createProfileToggleSingleFilter,
    datePickerGenericFilter,
    // sorting functions
    enumValueSort,
    enumOrderSort,
    enumLabelSort,
    enumPrecedenceSort,
    createNumericTripletMultiFilter,
    createSchoolDistrictEnrollmentFilter,
} from "shared/search/containers/Filter/Filters"
import {
    enumOrderDescendingSort,
    enumGenericFilter,
    enumCompositeStringFilter,
    toggleGenericFilter,
    searchifySelectGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    ArticleFilterableListView,
    BillFilterableListView,
    CampaignSearchifyFLV,
    DocumentFilterableListView,
    SupporterFilterableListView,
    NoteFilterableListView,
    CommitteeFilterableListView,
    CaucusFilterableListView,
    PublicOrganizationFilterableListView,
    CanadianFederalElectoralDistrictSearchifyFLV,
    CountrySearchifyFLV,
    CustomRegionSearchifyFLV,
    VoteFilterableListView,
    BulkUploadFileFLV,
    CampaignFilterableListView,
    IssueManagementFilterableListView,
    PublicOrganizationPartyFilterableListView,
    StateSearchifyFLV,
    CountySearchifyFLV,
    MunicipalitySearchifyFLV,
    BeatSearchifyFLV,
    UserFilterableListView,
    SocialDocumentFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    ActiveCampaignSelect,
    ArticleSelect,
    BillSelect,
    BulkUploadFileSelect,
    CampaignSelect,
    CanadianFederalElectoralDistrictSelect,
    CaucusSelect,
    CommitteeSelect,
    ContactSelect,
    CustomEventSelect,
    CustomGeoDataSelect,
    CountrySelect,
    CountryEUSelect,
    DMASelect,
    DocumentSelect,
    IssueManagementSelect,
    OutletSelect,
    PublicOrganizationPartySelect,
    PublicOrganizationNonCustomSelect,
    NoteSelect,
    VoteSelect,
    StateSelect,
    CountySelect,
    MunicipalitySelect,
    BeatSelect,
    UserSelect,
    SocialMediaSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import {
    CirculationSelect,
    DateListSelect,
    DegreeSelect,
    ElectionYearSelect,
    EthnicitySelect,
    FrequencySelect,
    LanguageSelect,
    LegislatorOnCommitteeTypeSelect,
    OfficialApointedByTypeSelect,
    ReligionSelect,
} from "app/static/frontend/selects/containers/EnumSelect"

import {
    PoliticalCommitteeCampaignFinanceReceivedMoneyFilter,
    PoliticalCommitteeCampaignFinanceReceiptsAmountMinFilter,
    PoliticalCommitteeCampaignFinanceReceiptsAmountMaxFilter,
    PoliticalCommitteeCampaignFinanceReceiptsDateStartFilter,
    PoliticalCommitteeCampaignFinanceReceiptsDateEndFilter,
    PoliticalCommitteeCampaignFinanceReceiptsContributorCommitteesFilter,
    PoliticalCommitteeCampaignFinanceReceiptsLegislatorFilter,
} from "shared/search/containers/Filter/PoliticalCommitteeFilters"

/** ***************************************************************************
 *
 * Filters for Persons! Probably will be moved into another file one day.
 *
 ***************************************************************************** */

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    helpText: PropTypes.string,
    selectComponent: PropTypes.func,
    placeholderText: PropTypes.string,
    regions: PropTypes.array,
}

const dateDefaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    noFuture: PropTypes.bool,
    regions: PropTypes.array,
}

export class OfficialTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "officialTypeFilter",
        filterKey: "ph_minor_role_type",
        // use enum items from both MinorRoleType and MajorRoleType since we need them for the new filters.
        // We add a property of 'type' to specify from which enum type this item is from.
        enumItems: DjangIO.app.person.newtypes.MinorRoleType.region_supported_items().filter((item) => {
            // For School Boards, we need to check if the user doesn't have other local permissions.
            // This is due the overlapping between both permissions and what we actually need to show in the filter.
            const { isExclusivelySchoolBoard, canSeeSchoolBoards } = checkIfShouldShowSchoolBoard()
            const isSchoolBoardMember =
                item.value === DjangIO.app.person.newtypes.MinorRoleType.school_board_member.value

            if (isExclusivelySchoolBoard) {
                return isSchoolBoardMember
            }
            if (!canSeeSchoolBoards && isSchoolBoardMember) {
                return false
            }

            // Include all other items by default.
            return true
        }),
        enumGroups: DjangIO.app.person.newtypes.MinorRoleType.filter_groups.filter(
            (group) =>
                !["Legislative Staff", "Leadership Staff", "Executive Staff", "Committee Staff"].includes(group.title),
        ),
        sortBy: enumOrderSort,
        excludedRegions: allRegionsExceptUS,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CandidateTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "candidateMinorRoleTypeFilter",
        filterKey: "candidate_minor_role_types",
        enumItems: [
            {
                key: "1",
                value: 1,
                label: "Congressional office",
            },
            {
                key: "2",
                value: 2,
                label: "State-wide office",
            },
            // TODO: add another enumItem here for "Presidential" candidates when
            // product sees fit
        ],
        displayLabel: "Challengers",
        regions: usRegions,
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EUMinorRoleFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "minorRoleFilter",
        filterKey: "ph_minor_role_type",
        enumItems: DjangIO.app.person.newtypes.MinorRoleType.region_supported_items(),
        enumGroups: DjangIO.app.person.newtypes.MinorRoleType.filter_groups,
        onlyRegions: euRegion,
        excludedRegions: internationalRegions,
        sortBy: enumOrderSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EUOfficialTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "EUOfficialTypeParliamentFilter",
        componentKey: "eu", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "for_staffer_types",
        enumItems: DjangIO.app.person.types.StafferType.region_supported_items(),
        enumGroups: DjangIO.app.person.types.StafferType.filter_groups,
        sortBy: enumLabelSort,
        regions: euRegion,
        excludedRegions: euRegion,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficialLastModifiedByFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "officialLastModifiedBy",
            filterKey: "last_modified_by",
            searchifyFLV: UserFilterableListView,
            dataTypeLabel: "Team Members",
            selectComponent: UserSelect,
            displayLabel: "Last Modified By...",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficialInternationalTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "officialInternationalTypeFilter",
        filterKey: "ph_major_role_type",
        enumItems: DjangIO.app.person.newtypes.MajorRoleType.region_supported_items(),
        enumGroups: DjangIO.app.person.newtypes.MajorRoleType.filter_groups,
        sortBy: enumOrderSort,
        displayKey: "title",
        regions: internationalNoEURegion,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const LegislatorTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
LegislatorTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "legislatorTypeFilter",
    filterKey: "ph_minor_role_type",
    enumItems: DjangIO.app.person.newtypes.MinorRoleType.region_supported_items().filter((item) =>
        DjangIO.app.person.newtypes.MinorRoleType.role_groups.legislators_all.includes(item.value),
    ),
    sortBy: enumOrderSort,
}

export const ExecutiveTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
ExecutiveTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "executiveTypeFilter",
    filterKey: "ph_minor_role_type",
    enumItems: DjangIO.app.person.newtypes.MinorRoleType.region_supported_items().filter((item) =>
        DjangIO.app.person.newtypes.MinorRoleType.role_groups.execs_all.includes(item.value),
    ),
    sortBy: enumOrderSort,
}

export class LocalExecutiveTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "localExecTypeFilter",
        filterKey: "local_person_type",
        enumItems: isFeatureEnabled("ff_lc_kw_failover")
            ? DjangIO.app.person.types.SpecificLocalExecutiveRoleType.region_supported_items().filter(
                  (item) => item.value !== DjangIO.app.person.types.SpecificLocalExecutiveRoleType.judge.value,
              )
            : DjangIO.app.person.types.SpecificLocalExecutiveRoleType.region_supported_items(),
        enumGroups: DjangIO.app.person.types.SpecificLocalExecutiveRoleType.filter_groups,
        sortBy: enumValueSort,
        regions: localRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonStatusFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "personStatusFilter",
        filterKey: "ph_current",
        trueText: "Current",
        falseText: "Former",
        displayLabel: "Status",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CustomOfficialsFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "customOfficialsFilter",
        filterKey: "custom_official",
        trueText: "Custom officials only",
        falseText: "Quorum officials only",
        displayLabel: "Custom Officials",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonNextElectionFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "personNextElectionFilter",
        filterKey: "most_recent_role__reelectionyear__in",
        sortBy: enumValueSort,
        displayLabel: "Next Election Year",
        regions: federalAndStates,
        selectComponent: ElectionYearSelect,
        enumItems: getElectionYearSelectOptions(),
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonIncomingStatusFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "personIncomingStatusFilter",
        filterKey: "status__in",
        enumItems: DjangIO.app.person.types.PersonStatus.items().filter(
            (item) => item.value !== DjangIO.app.person.types.PersonStatus.former.value,
        ),
        sortBy: enumValueSort,
        displayLabel: "Election Status",
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DateAssumedOfficeAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "dateAssumedOfficeAfterFilter",
        filterKey: "date_assumed_office_after",
        displayLabel: "Appointment Start Date After",
        noFuture: true,
        helpText: "Filter by when appointed officials assumed office.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DateAssumedOfficeBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "dateAssumedOfficeBeforeFilter",
        filterKey: "date_assumed_office_before",
        displayLabel: "Appointment Start Date Before",
        noFuture: true,
        helpText: "Filter by when appointed officials assumed office.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class FirstElectedAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "firstElectedAfterFilter",
        filterKey: "first_elected_after",
        displayLabel: "First Elected After",
        noFuture: true,
        helpText: "Filter by when officials were first elected to their current role.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class FirstElectedBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "firstElectedBeforeFilter",
        filterKey: "first_elected_before",
        displayLabel: "First Elected Before",
        noFuture: true,
        helpText: "Filter by when officials were first elected to their current role.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislativeSeniorityFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "officialSeniorityFilter",
        filterKey: "legislative_seniority",
        enumItems: DjangIO.app.person.types.LegislativeSeniority.region_supported_items(),
        sortBy: enumValueSort,
        displayLabel: "Seniority",
        regions: federalRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislativeLeadershipFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "officialLeadershipFilter",
        filterKey: "leadership_type",
        displayLabel: "Leadership",
        enumItems: DjangIO.app.person.types.PersonLeadershipType.region_supported_items(),
        sortBy: enumValueSort,
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const NumberOfTermsFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "numberOfTermsFilter",
    displayLabel: "Number of Terms",
    filterKeyMapping: {
        left: "number_of_terms_less_than",
        center: "number_of_terms_is_exactly",
        right: "number_of_terms_greater_than",
    },
    regions: [...allRegionsExceptLocal],
})

export class ExecutiveWorksForFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "execWorksForFilter",
            filterKey: "associated_with_organization",
            searchifyPermanentFilter: { non_custom_only: true },
            dataTypeLabel: "Organizations",
            displayLabel: "Works For (Organization)",
            searchifyFLV: PublicOrganizationFilterableListView,
            selectComponent: PublicOrganizationNonCustomSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ExecutiveTitleFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "execTitleFilter",
        filterKey: "title_search",
        placeholderText: "Search text of title...",
        displayLabel: "Search Titles",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficialPayScaleFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "officialPayScaleFilter",
        filterKey: "contains_pay_scale_type",
        enumItems: DjangIO.app.person.types.PayScaleType.region_supported_items(),
        sortBy: enumOrderSort,
        regions: federalRegions,
        displayLabel: "Fed Pay Scale",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficialAppointedByTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "officialAppointedByTypeFilter",
        filterKey: "contains_appointed_by_types",
        enumItems: DjangIO.app.person.types.AppointedByType.region_supported_items(),
        sortBy: enumValueSort,
        regions: usRegions,
        selectComponent: OfficialApointedByTypeSelect,
        displayLabel: "Appointment Type",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficialPartyFilter extends Component {
    static defaultProps = {
        filterComponent: enumCompositeStringFilter,
        uniqueFilterId: "officialPartyFilter",
        filterKey: "most_recent_party__in",
        enumItems: DjangIO.app.person.types.Party.region_supported_items()
            .filter((item) => item.value !== DjangIO.app.person.types.Party.NoParty.value)
            .map((item) => ({
                ...item,
                value:
                    item.value === DjangIO.app.person.types.Party.Democrat.value
                        ? [
                              DjangIO.app.person.types.Party.Democrat.value.toString(),
                              DjangIO.app.person.types.Party.ppd.value.toString(),
                          ]
                        : item.value === DjangIO.app.person.types.Party.Republican.value
                          ? [
                                DjangIO.app.person.types.Party.Republican.value.toString(),
                                DjangIO.app.person.types.Party.pnp.value.toString(),
                            ]
                          : item.value.toString(),
            })),
        sortBy: enumLabelSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficialPartyInternationalFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "officialPartyInternationalFilter",
            filterKey: "associated_with_organization",
            displayLabel: "Parties",
            dataTypeLabel: "Parties",
            regions: allRegionsExceptUS,
            searchifyFLV: PublicOrganizationPartyFilterableListView,
            selectComponent: PublicOrganizationPartySelect,
            searchifyPermanentFilter: {
                non_custom_only: true,
                political_major_organization_type: true,
            },
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorOnCommitteeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "onCommitteeFilter",
            filterKey: "on_committees",
            displayLabel: Userdata.isOnlyEUMode() ? "MEPs who sit on any of..." : "Legislators who sit on any of…",
            dataTypeLabel: "Committees",
            regions: federalAndStates.concat(euRegions),
            searchifyFLV: CommitteeFilterableListView,
            selectComponent: CommitteeSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorOnCaucusFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "onCaucusFilter",
            filterKey: "on_caucuses",
            dataTypeLabel: "Caucuses",
            regions: federalRegions,
            searchifyFLV: CaucusFilterableListView,
            selectComponent: CaucusSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorOnCommitteeTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "onCommitteeTypeFilter",
        filterKey: "committee_keywords",
        enumItems: DjangIO.app.committee.models.CommitteeKeyword.region_supported_items(),
        sortBy: enumValueSort,
        displayLabel: "On committees of the type...",
        regions: stateRegions,
        selectComponent: LegislatorOnCommitteeTypeSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CommitteeLeadershipFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "committeeLeadershipFilter",
        filterKey: "committee_leadership",
        enumItems: DjangIO.app.person.searchfiltertypes.CommitteeLeadershipType.items(),
        sortBy: enumValueSort,
        displayLabel: "Leadership",
        regions: federalAndStates,
        helpText: "This filter will show Chairs and Ranking Members of both Committees and Subcommittees",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ChairOnCommitteeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "chairOnCommitteeFilter",
            filterKey: "chairs_on_committees",
            displayLabel: "Legislators who chair any of...",
            dataTypeLabel: "Committees",
            searchifyFLV: CommitteeFilterableListView,
            regions: federalAndStates,
            selectComponent: CommitteeSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// we might one day want an address autocomplete
export class PersonRepresentingAddressFilter extends Component {
    static defaultProps = {
        filterComponent: addressGenericFilter,
        uniqueFilterId: "reppingAddress",
        filterKey: "representing_address",
        placeholderText: "Search for an address...",
        regions: usAndCanadaRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonRepresentingCustomGeographyFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingCustomGeo",
            filterKey: "representing_custom_geo_data",
            dataTypeLabel: "Custom Geographic Data Set",
            displayLabel: "Custom Data",
            multi: false,
            regions: usRegions,
            permissions: [DjangIO.app.models.PermissionType.custom_data],
            searchifyFLV: CustomRegionSearchifyFLV,
            selectComponent: CustomGeoDataSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonRepresentingCountryAllFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingCountry",
            filterKey: "representing_country",
            dataTypeLabel: "Countries",
            searchifyFLV: CountrySearchifyFLV,
            searchifyPermanentFilter: { filter_by_user_region: true },
            selectComponent: CountrySelect,
            regions: globalRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonRepresentingCountryEUFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingCountryEU",
            filterKey: "representing_country",
            regions: euRegions,
            selectComponent: CountryEUSelect,
            searchifyFLV: CountrySearchifyFLV,
            searchifyPermanentFilter: { only_eu_countries: true },
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonRepresentingCanadianFederalElectoralDistrictFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingCanadianDistrict",
            filterKey: "representing_geo_shapes",
            onlyRegions: [DjangIO.app.models.Region.canada.value],
            selectComponent: CanadianFederalElectoralDistrictSelect,
            searchifyFLV: CanadianFederalElectoralDistrictSearchifyFLV,
            searchifyPermanentFilter: {
                geo_shape_type: DjangIO.app.geography.types.GeoShapeType.canadian_federal_electoral_district.value,
            },
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonRepresentingContactsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "personRepresentsContactFilter",
            filterKey: "representing_contacts",
            dataTypeLabel: "Contacts",
            displayLabel: "Representing contacts...",
            searchifyFLV: SupporterFilterableListView,
            selectComponent: ContactSelect,
            permissions: [DjangIO.app.models.PermissionType.custom_contacts],
            regions: usCanadaEURegion,
            searchifyPermanentFilter: {
                address_geocoded: true,
            },
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonInteractedInNotesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "personInteractedInNotesFilter",
            filterKey: "participated_in_notes",
            displayLabel: "Participated in notes...",
            dataTypeLabel: "Notes",
            searchifyFLV: NoteFilterableListView,
            selectComponent: NoteSelect,
            helpText:
                "Use Search to select a set of interactions or relationships. " +
                "This filter will then show only the individuals who participated in those interactions " +
                "or relationships, but not by office.",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficeInteractedInNotesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "officeInteractedInNotesFilter",
            filterKey: "office_participated_in_notes",
            displayLabel: "Office participated in notes…",
            dataTypeLabel: "Notes",
            searchifyFLV: NoteFilterableListView,
            selectComponent: NoteSelect,
            helpText:
                "Use Search to select a set of interactions or relationships. " +
                "This filter will then show only the individuals who participated in those interactions " +
                "or relationships by office.",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonInteractedDateFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "personInteractedDateFilter",
        filterKey: "interacted_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
        displayLabel: "Most recent interaction...",
        sortBy: enumValueSort,
        selectComponent: DateListSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonNotInteractedDateFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "personNotInteractedDateFilter",
        filterKey: "not_interacted_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
        displayLabel: "Has not interacted...",
        sortBy: enumValueSort,
        selectComponent: DateListSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorSponsoredFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorSponsoredFilter",
            filterKey: "sponsored_bills",
            dataTypeLabel: "Bills",
            displayLabel: "Legislators who sponsored...",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorCosponsoredFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorCosponsoredFilter",
            filterKey: "cosponsored_bills",
            dataTypeLabel: "Bills",
            displayLabel: "Legislators who cosponsored...",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorSponsoredOrCosponsoredFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorSponsoredOrCosponsoredFilter",
            filterKey: "sponsored_or_cosponsored_bills",
            dataTypeLabel: "Bills",
            displayLabel: "Sponsored or cosponsored...",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorDidNotSponsorOrCosponsorFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorDidNotSponsorOrCosponsorFilter",
            filterKey: "did_not_sponsor_or_cosponsor_bills",
            dataTypeLabel: "Bills",
            displayLabel: "Did not sponsor or cosponsor...",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorVotedYesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorVotedYesFilter",
            filterKey: "voted_yes",
            dataTypeLabel: "Bills",
            displayLabel: "Legislators who voted yes on...",
            searchifyFLV: VoteFilterableListView,
            selectComponent: VoteSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorVotedNoFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorVotedNoFilter",
            filterKey: "voted_no",
            dataTypeLabel: "Bills",
            displayLabel: "Legislators who voted no on...",
            searchifyFLV: VoteFilterableListView,
            selectComponent: VoteSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorRapporteurFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorRapporteurFilter",
            filterKey: "rapporteur_bills",
            dataTypeLabel: "Bills",
            displayLabel: "Legislators who rapporteur on...",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorShadowRapporteurFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorShadowRapporteurFilter",
            filterKey: "shadow_rapporteur_bills",
            dataTypeLabel: "Bills",
            displayLabel: "Legislators who shadow rapporteur on...",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislatorShadowOrRapporteurFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legislatorShadowOrRapporteurFilter",
            filterKey: "shadow_or_rapporteur_bills",
            dataTypeLabel: "Bills",
            displayLabel: "Legislators who shadow or rapporteur on...",
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonBioSearchFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "personBioSearch",
        filterKey: "qualitative_bio_search",
        placeholderText: "Search biographies...",
        displayLabel: "Biographies",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonCustomBioSearchFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "personCustomBioSearch",
        filterKey: "custom_bio_search",
        placeholderText: "Search custom description...",
        displayLabel: "Custom Description",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonGenderFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "personGenderFilter",
        filterKey: "gender_bool",
        displayLabel: "Gender",
        trueText: "Male",
        falseText: "Female",
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonMilitaryFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "personMilitaryFilter",
        filterKey: "military",
        trueText: "Military",
        falseText: "Non-military",
        regions: federalAndStates,
        displayLabel: "Military Status",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonEthnicityFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "personEthnicityFilter",
        filterKey: "ethnicity",
        displayLabel: "Ethnicity",
        enumItems: DjangIO.app.person.types.Ethnicity.region_supported_items(),
        selectComponent: EthnicitySelect,
        sortBy: enumLabelSort,
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonReligionFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "personReligionFilter",
        filterKey: "religion",
        enumItems: DjangIO.app.person.types.Religion.region_supported_items(),
        selectComponent: ReligionSelect,
        displayLabel: "Religion",
        sortBy: enumLabelSort,
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PersonDegreeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "personDegreeFilter",
        filterKey: "terminal_degree",
        enumItems: DjangIO.app.person.types.TerminalDegree.region_supported_items(),
        selectComponent: DegreeSelect,
        displayLabel: "Terminal Degree",
        sortBy: enumOrderSort,
        regions: federalAndStates,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PersonUniversityFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
PersonUniversityFilter.propTypes = defaultPropTypes
PersonUniversityFilter.defaultProps = {
    displayLabel: "University",
    filterComponent: textGenericFilter,
    filterKey: "university_search",
    helpText: "You can search for multiple universities by separating your inputs with a comma",
    placeholderText: "Search for university...",
    regions: federalAndStates,
    uniqueFilterId: "personUniversityFilter",
}

export class OfficialFromBulkUploadFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "officialFromBulkUploadFilter",
            filterKey: "from_bulk_upload_files",
            searchifyFLV: BulkUploadFileFLV,
            searchifyPermanentFilter: {
                upload_type: DjangIO.app.custom_data.types.BulkUploadType.official.value,
                status: DjangIO.app.custom_data.types.BulkUploadStatus.finished.value,
            },
            dataTypeLabel: "Officals Bulk Uploads",
            displayLabel: "Bulk upload files...",
            selectComponent: BulkUploadFileSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PersonDocumentFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={DocumentFilterableListView} {...props} />
}
PersonDocumentFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
PersonDocumentFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "personDocumentFilter",
    filterKey: "searchify_source_document",
    dataTypeLabel: "Documents",
    selectComponent: DocumentSelect,
}

export const PersonAgeFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "personAgeFilter",
    displayLabel: "Age",
    filterKeyMapping: { left: "age_less_than", center: "age_is_exactly", right: "age_greater_than" },
    regions: [...allRegionsExceptLocal],
})

/*************************************************************
 * Profile specific filters!
 **************************************************************/
export const OfficialSponsorBillProfileFilter = createProfileToggleFilter({
    uniqueFilterId: "officialSponsor",
    trueText: "Sponsors",
    falseText: "Cosponsors",
    filterKeyMapping: {
        true: "sponsored",
        false: "cosponsored",
    },
    regions: usRegions,
})

// Profile-specfic filters
export const OfficialOrganizatonsFilter = createProfileToggleSingleFilter({
    uniqueFilterId: "officialOrganizatonsFilter",
    trueText: "Current Org Only",
    filterKeyMapping: {
        true: "associated_with_organization",
    },
})

export const OfficialProjectFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={IssueManagementFilterableListView} {...props} />
}
OfficialProjectFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
OfficialProjectFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialProjectFilter",
    filterKey: "for_project_and_subprojects",
    dataTypeLabel: "Issues",
    selectComponent: IssueManagementSelect,
}

export const OfficialCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
OfficialCustomEventFilter.propTypes = defaultPropTypes
OfficialCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customEventParticipantEventFilter",
    filterKey: "involved_in_event_searchify",
    dataTypeLabel: "Added to Event",
    displayLabel: "Added to Event",
    selectComponent: CustomEventSelect,
}

export const OfficialInvitedToEventCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
OfficialInvitedToEventCustomEventFilter.propTypes = defaultPropTypes
OfficialInvitedToEventCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialInvitedToEventCustomEventFilter",
    filterKey: "invited_to_event_searchify",
    dataTypeLabel: "Emailed About Event",
    displayLabel: "Emailed About Event",
    selectComponent: CustomEventSelect,
}

export const OfficialHasNotRsvpCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
OfficialHasNotRsvpCustomEventFilter.propTypes = defaultPropTypes
OfficialHasNotRsvpCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasNotRsvpCustomEventFilter",
    filterKey: "has_not_rsvped_searchify",
    dataTypeLabel: "Has Not not RSVP'd to Event",
    displayLabel: "Has Not RSVP'd to Event",
    selectComponent: CustomEventSelect,
}

export const OfficialHasRsvpYesCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
OfficialHasRsvpYesCustomEventFilter.propTypes = defaultPropTypes
OfficialHasRsvpYesCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasRsvpYesCustomEventFilter",
    filterKey: "has_rsvped_yes_searchify",
    dataTypeLabel: "RSVP'd Yes to Event",
    displayLabel: "RSVP'd Yes to Event",
    selectComponent: CustomEventSelect,
}

export const OfficialHasRsvpNoCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
OfficialHasRsvpNoCustomEventFilter.propTypes = defaultPropTypes
OfficialHasRsvpNoCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasRsvpNoCustomEventFilter",
    filterKey: "has_rsvped_no_searchify",
    dataTypeLabel: "RSVP'd No to Event",
    displayLabel: "RSVP'd No to Event",
    selectComponent: CustomEventSelect,
}

export const OfficialHasRsvpMaybeCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
OfficialHasRsvpMaybeCustomEventFilter.propTypes = defaultPropTypes
OfficialHasRsvpMaybeCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasRsvpMaybeCustomEventFilter",
    filterKey: "has_rsvped_maybe_searchify",
    dataTypeLabel: "RSVP'd Maybe to Event",
    displayLabel: "RSVP'd Maybe to Event",
    selectComponent: CustomEventSelect,
}

export const OfficialAttendedCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
OfficialAttendedCustomEventFilter.propTypes = defaultPropTypes
OfficialAttendedCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialAttendedCustomEventFilter",
    filterKey: "attended_event_searchify",
    dataTypeLabel: "Attended Event",
    displayLabel: "Attended Event",
    selectComponent: CustomEventSelect,
}

export const PersonInternationalRegionFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
PersonInternationalRegionFilter.propTypes = defaultPropTypes
PersonInternationalRegionFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "personInternationalRegionFilter",
    filterKey: "region_search",
    placeholderText: "Search for region...",
    displayLabel: "Region Search",
}

export const PersonBirthdayPickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
PersonBirthdayPickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
PersonBirthdayPickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "personBirthdayPickerStartNoFutureFilter",
    filterKey: "birthdate_after",
    displayLabel: "Birthday Start Date",
    noFuture: true,
    regions: [...allRegionsExceptLocal],
    helpText: "Birthday after date selected. Excludes date selected.",
}

export const PersonBirthdayPickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
PersonBirthdayPickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
PersonBirthdayPickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "personBirthdayPickerEndNoFutureFilter",
    filterKey: "birthdate_before",
    displayLabel: "Birthday End Date",
    noFuture: true,
    regions: [...allRegionsExceptLocal],
    helpText: "Birthday before date selected. Excludes date selected.",
}

export class PersonCampaignFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "personCampaignFilter",
            filterKey: "officials_in_campaign",
            searchifyFLV: CampaignFilterableListView,
            dataTypeLabel: "Was contacted in grassroots campaign(s)...",
            selectComponent: CampaignSelect,
            displayLabel: "Was contacted in grassroots campaigns...",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PersonTargetedByCampaignFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent searchifyFLV={CampaignSearchifyFLV} {...props} />
}
PersonTargetedByCampaignFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "personTargetedByCampaignFilter",
    filterKey: "for_campaigns",
    displayLabel: "Targeted by campaigns...",
    helpText: "Use Search to select officials targeted by specific campaigns",
    dataTypeLabel: "Campaigns",
    selectComponent: ActiveCampaignSelect,
}

export class PersonTitleFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "personTitleFilter",
        filterKey: "title_search",
        placeholderText: "Search text of title...",
        displayLabel: "Search Titles",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PersonDonationAggregateFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "personDonationAggregateFilter",
    displayLabel: "Aggregate Amount Donated",
    filterKeyMapping: {
        left: "donation_aggregate_lt",
        center: "donation_aggregate_eq",
        right: "donation_aggregate_gt",
    },
    regions: usRegions,
})

export class PressContactLanguageFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: enumGenericFilter,
            isProtected: true,
            uniqueFilterId: "pressContactLanguages",
            filterKey: "languages",
            enumItems: DjangIO.app.document.types.Language.region_supported_items(),
            sortBy: enumOrderDescendingSort,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactMajorRoleTypeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "pressContactMajorRoleTypeFilter",
            filterKey: "major_role_types",
            displayLabel: "Role Type",
            enumItems: DjangIO.app.person.newtypes.MajorRoleType.region_supported_items().filter(
                (item) => item.parent === DjangIO.app.person.newtypes.MetaRoleType.media_meta.value,
            ),
            sortBy: enumValueSort,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactOutletFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Works For",
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "associatedWithOutletFilter",
            filterKey: "associated_with_organization",
            dataTypeLabel: "Organizations",
            searchifyFLV: PublicOrganizationFilterableListView,
            selectComponent: OutletSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactOutletFrequencyFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Publication Frequency",
            enumItems: DjangIO.app.media_monitoring.types.IntradoFrequency.items(),
            filterComponent: enumGenericFilter,
            filterKey: "primary_organization__intrado_frequency__in",
            selectComponent: FrequencySelect,
            sortBy: enumValueSort,
            uniqueFilterId: "pressContactOutletFrequencyFilter",
            permissions: [DjangIO.app.models.PermissionType.media_relations],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
export class PressContactOutletCirculationFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Circulation",
            enumItems: DjangIO.app.media_monitoring.types.IntradoCirculation.items(),
            filterComponent: enumGenericFilter,
            filterKey: "outlet_circulation",
            selectComponent: CirculationSelect,
            sortBy: enumValueSort,
            uniqueFilterId: "pressContactOutletCirculationFilter",
            permissions: [DjangIO.app.models.PermissionType.media_relations],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactOutletLanguageFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Language",
            enumItems: DjangIO.app.document.types.Language.items(),
            filterComponent: enumGenericFilter,
            filterKey: "primary_organization__intrado_language__in",
            sortBy: enumOrderDescendingSort,
            uniqueFilterId: "pressContactOutletLanguageFilter",
            permissions: [DjangIO.app.models.PermissionType.media_relations],
            selectComponent: LanguageSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactOutletCategoryFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Outlet Category",
            filterComponent: enumGenericFilter,
            uniqueFilterId: "associatedWithOutletCategoryFilter",
            filterKey: "primary_organization__ln_category__in",
            enumItems: DjangIO.app.media_monitoring.types.MediaSourceCategory.region_supported_items(),
            sortBy: enumLabelSort,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactOutletTypeFilter extends Component {
    static get defaultProps() {
        const { SectorType, MetaOrganizationType, NewMajorOrganizationType } = DjangIO.app.person.newtypes

        return {
            displayLabel: "Outlet Type",
            filterComponent: enumGenericFilter,
            uniqueFilterId: "outletTypeFilter",
            filterKey: "outlet_subtype",
            enumItems: NewMajorOrganizationType.items(),
            enumGroups: MetaOrganizationType.items()
                .filter((item) => item.parent === SectorType.media.value)
                .sort(enumPrecedenceSort)
                .map((item) => ({
                    title: item.label,
                    values: NewMajorOrganizationType.items()
                        .filter((subItem) => subItem.parent === item.value)
                        .sort(enumLabelSort)
                        .map((subItem) => subItem.value),
                    collapseGroup: true,
                })),
            sortBy: enumValueSort,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactOutletCoverageFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Outlet Coverage",
            filterComponent: enumGenericFilter,
            uniqueFilterId: "outletCoverageFilter",
            filterKey: "outlet_coverage",
            enumItems: DjangIO.app.media_monitoring.types.MediaSourceCategory.region_supported_items(),
            sortBy: enumLabelSort,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactAddressFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: addressGenericFilter,
            uniqueFilterId: "pressContactAddressFilter",
            filterKey: "outlet_address",
            placeholderText: "Search for an address...",
            regions: usAndCanadaRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactCountryFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactCountryFilter",
            filterKey: "outlet_country",
            dataTypeLabel: "Countries",
            searchifyFLV: CountrySearchifyFLV,
            selectComponent: CountrySelect,
            regions: internationalNoEURegion,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactCountryEUFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactCountryEUFilter",
            filterKey: "outlet_country",
            regions: euRegion,
            selectComponent: CountryEUSelect,
            searchifyFLV: CountrySearchifyFLV,
            searchifyPermanentFilter: { only_eu_countries: true },
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactStateFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactStateFilter",
            filterKey: "outlet_state",
            dataTypeLabel: "States & Territories",
            searchifyFLV: StateSearchifyFLV,
            selectComponent: StateSelect,
            regions: usRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactCountyFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactCountyFilter",
            filterKey: "outlet_county",
            dataTypeLabel: "Counties",
            searchifyFLV: CountySearchifyFLV,
            selectComponent: CountySelect,
            permissions: [DjangIO.app.models.PermissionType.local],
            regions: usRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactMunicipalityFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactMunicipalityFilter",
            filterKey: "outlet_municipality",
            dataTypeLabel: "Towns and Cities",
            searchifyFLV: MunicipalitySearchifyFLV,
            selectComponent: MunicipalitySelect,
            regions: usRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactBeatFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactBeatFilter",
            filterKey: "beats",
            searchifyFLV: BeatSearchifyFLV,
            dataTypeLabel: "Beats",
            displayLabel: "Beats",
            selectComponent: BeatSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactDMAFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactDMAFilter",
            filterKey: "market_area",
            dataTypeLabel: "DMA",
            selectComponent: DMASelect,
            permissions: [DjangIO.app.models.PermissionType.media_relations],
            regions: usAndCanadaRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressContactArticleFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactArticleFilter",
            filterKey: "associated_with_article",
            dataTypeLabel: "News Articles",
            displayLabel: "News Articles",
            searchifyFLV: ArticleFilterableListView,
            selectComponent: ArticleSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PressContactCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PressContactCustomEventFilter.propTypes = defaultPropTypes
PressContactCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customEventParticipantEventFilter",
    filterKey: "press_involved_in_event_searchify",
    dataTypeLabel: "Added to Event",
    displayLabel: "Added to Event",
    selectComponent: CustomEventSelect,
}

export const PressContactInvitedToEventCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PressContactInvitedToEventCustomEventFilter.propTypes = defaultPropTypes
PressContactInvitedToEventCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "pressContactInvitedToEventCustomEventFilter",
    filterKey: "press_invited_to_event_searchify",
    dataTypeLabel: "Emailed About Event",
    displayLabel: "Emailed About Event",
    selectComponent: CustomEventSelect,
}

export const PressContactHasNotRsvpCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PressContactHasNotRsvpCustomEventFilter.propTypes = defaultPropTypes
PressContactHasNotRsvpCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "pressContactHasNotRsvpCustomEventFilter",
    filterKey: "press_has_not_rsvped_searchify",
    dataTypeLabel: "Has Not not RSVP'd to Event",
    displayLabel: "Has Not RSVP'd to Event",
    selectComponent: CustomEventSelect,
}

export const PressContactHasRsvpYesCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PressContactHasRsvpYesCustomEventFilter.propTypes = defaultPropTypes
PressContactHasRsvpYesCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "pressContactHasRsvpYesCustomEventFilter",
    filterKey: "press_has_rsvped_yes_searchify",
    dataTypeLabel: "RSVP'd Yes to Event",
    displayLabel: "RSVP'd Yes to Event",
    selectComponent: CustomEventSelect,
}

export const PressContactHasRsvpNoCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PressContactHasRsvpNoCustomEventFilter.propTypes = defaultPropTypes
PressContactHasRsvpNoCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "pressContactHasRsvpNoCustomEventFilter",
    filterKey: "press_has_rsvped_no_searchify",
    dataTypeLabel: "RSVP'd No to Event",
    displayLabel: "RSVP'd No to Event",
    selectComponent: CustomEventSelect,
}

export const PressContactHasRsvpMaybeCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PressContactHasRsvpMaybeCustomEventFilter.propTypes = defaultPropTypes
PressContactHasRsvpMaybeCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "pressContactHasRsvpMaybeCustomEventFilter",
    filterKey: "press_has_rsvped_maybe_searchify",
    dataTypeLabel: "RSVP'd Maybe to Event",
    displayLabel: "RSVP'd Maybe to Event",
    selectComponent: CustomEventSelect,
}

export const PressContactAttendedCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PressContactAttendedCustomEventFilter.propTypes = defaultPropTypes
PressContactAttendedCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "pressContactAttendedCustomEventFilter",
    filterKey: "press_attended_event_searchify",
    dataTypeLabel: "Attended Event",
    displayLabel: "Attended Event",
    selectComponent: CustomEventSelect,
}

export const PressContactSocialMediaFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}

PressContactSocialMediaFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "pressContactSocialMediaFilter",
    filterKey: "searchify_source_document",
    dataTypeLabel: "Tweets",
    searchifyFlv: SocialDocumentFilterableListView,
    selectComponent: SocialMediaSelect,
    permissions: [DjangIO.app.models.PermissionType.media_relations],
}

export class PressContactFromBulkUploadFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressContactFromBulkUploadFilter",
            filterKey: "from_bulk_upload_files",
            searchifyFLV: BulkUploadFileFLV,
            searchifyPermanentFilter: {
                upload_type: DjangIO.app.custom_data.types.BulkUploadType.press_contact.value,
                status: DjangIO.app.custom_data.types.BulkUploadStatus.finished.value,
            },
            dataTypeLabel: "Press Contacts Bulk Uploads",
            displayLabel: "Bulk upload files...",
            selectComponent: BulkUploadFileSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const OfficialsRepresentingSchoolDistrictEnrollmentMinFilter = createSchoolDistrictEnrollmentFilter({
    uniqueFilterId: "official_rep_sd_enrollment_min",
    filterKey: "associated_sd_min_enrollment",
    isMin: true,
})

export const OfficialsRepresentingSchoolDistrictEnrollmentMaxFilter = createSchoolDistrictEnrollmentFilter({
    uniqueFilterId: "official_rep_sd_enrollment_max",
    filterKey: "associated_sd_max_enrollment",
    isMin: false,
})

export class OfficialsCampaignFinanceReceivedMoneyFilter extends PoliticalCommitteeCampaignFinanceReceivedMoneyFilter {}
export class OfficialsCampaignFinanceReceiptsAmountMinFilter extends PoliticalCommitteeCampaignFinanceReceiptsAmountMinFilter {}
export class OfficialsCampaignFinanceReceiptsAmountMaxFilter extends PoliticalCommitteeCampaignFinanceReceiptsAmountMaxFilter {}
export class OfficialsCampaignFinanceReceiptsDateStartFilter extends PoliticalCommitteeCampaignFinanceReceiptsDateStartFilter {}
export class OfficialsCampaignFinanceReceiptsDateEndFilter extends PoliticalCommitteeCampaignFinanceReceiptsDateEndFilter {}
export class OfficialsCampaignFinanceReceiptsContributorCommitteesFilter extends PoliticalCommitteeCampaignFinanceReceiptsContributorCommitteesFilter {}
export class OfficialsCampaignFinanceReceiptsLegislatorFilter extends PoliticalCommitteeCampaignFinanceReceiptsLegislatorFilter {}
